import {SHORT_CODES} from "./constants";

export type ShortCodeToken = {
  /** Index of `{` in the full string */
  braceStart: number;
  /** Text after `{` up to the cursor (no closing `}`) */
  inner: string;
};

/** When the cursor is inside an unclosed `{...` segment, return its span for completion. */
export function parseIncompleteShortCodePrefix(
  textBeforeCursor: string
): ShortCodeToken | null {
  const match = textBeforeCursor.match(/\{([^}]*)$/);
  if (match == null) return null;
  const braceStart = textBeforeCursor.lastIndexOf("{");
  return {braceStart, inner: match[1] ?? ""};
}

export function shortCodeCompletionCandidates(inner: string) {
  const prefix = `{${inner}`.toLowerCase();
  return SHORT_CODES.filter(({code}) => code.toLowerCase().startsWith(prefix));
}

export function replaceShortCodeToken(
  full: string,
  braceStart: number,
  cursorPos: number,
  code: string
): {value: string; caret: number} {
  const value = full.slice(0, braceStart) + code + full.slice(cursorPos);
  return {value, caret: braceStart + code.length};
}
